import { render, staticRenderFns } from "./CustomerTestimonials.vue?vue&type=template&id=c71acd34&scoped=true"
import script from "./CustomerTestimonials.vue?vue&type=script&lang=js"
export * from "./CustomerTestimonials.vue?vue&type=script&lang=js"
import style0 from "./CustomerTestimonials.vue?vue&type=style&index=0&id=c71acd34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71acd34",
  null
  
)

export default component.exports